module.exports = __webpack_public_path__ + "static/media/explore.05675cd3.svg";